import { Injectable, inject } from '@angular/core';
import { Subscription, Subject } from 'rxjs';

import { GoalHttpService } from '../http/http.service';
import { GoalStatistics } from '../../model/statistics.model';

import { BroadcastService, BroadcastMessage } from '@app/core/service';

@Injectable()
export class GoalStatisticsService {
    /**
     * Loaded Flag
     */
    loaded = false;

    /**
     * Loading Flag
     */
    loading = false;

    /**
     * Statistics
     */
    statistics!: GoalStatistics;

    /**
     * Updates Subject
     */
    private updatesEvent = new Subject();

    /**
     * Subscriptions
     */
    private subscriptions = new Subscription();

    private goalHttpService = inject(GoalHttpService);
    private broadcastService = inject(BroadcastService);

    init(): void {
        this.load();
        this.subscriptions.add(this.broadcastService.broadcasts.subscribe((broadcast) => this.broadcasts(broadcast)));
    }

    destroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Updates Observable
     */
    get updates() {
        return this.updatesEvent.asObservable();
    }

    /**
     * Load Statistics
     */
    load(): void {
        if (this.loading) {
            return;
        }

        this.loading = true;
        this.updatesEvent.next(true);

        this.subscriptions.add(
            this.goalHttpService.getStatistics().subscribe((statistics) => {
                this.statistics = statistics;
                this.loaded = true;
                this.loading = false;
                this.updatesEvent.next(true);
            }),
        );
    }

    /**
     * Broadcast
     */
    private broadcasts(broadcast: BroadcastMessage): void {
        switch (broadcast.message) {
            case 'episode-completed':
            case 'episode-started':
            case 'user-self-edited':
            case 'lpwizard-lp-change':
                this.load();
                break;
        }
    }
}
